<template>
  <div>
    <!-- 头部标题 -->
    <template
      v-if="haveNavi"
    >
      <div
        class="listHead"
      >
        <div>
          <div class="sCircle" />
          <span style="font-size: 16px; font-weight: 700">导航管理</span>
        </div>
        <div
          class="addLinkBtn"
        >
          <el-button
            class="plainBtn cancel-button"
            size="small"
            @click="openNaviDialog"
          >
            添加
          </el-button>
        </div>
      </div>

      <div class="Pagedata tips">
        <div style="color: #999999;">
          <i class="el-icon-question"> 网站导航区最多可设置8项一级内容</i>
        </div>
      </div>

      <div class="Pagedata">
        <el-table
          v-if="naviList.length > 0"
          :data="naviList"
          border
          :show-header="true"
          :header-cell-style="headCss"
          default-expand-all
          row-key="id"
          :tree-props="{children: 'children'}"
          style="width: 100%"
        >
          <el-table-column
            prop="name"
            label="栏目名称"
            align="left"
          />
          <el-table-column
            label="操作"
            align="center"
            width="220"
          >
            <template slot-scope="{ row }">
              <div
                v-if="row.name!='首页'"
                class="tableRow navi"
              >
                <mix-tooltip
                  :enterable="false"
                  content="上移"
                  popper-class="user-table-tooltip weight"
                  placement="top"
                  effect="light"
                >
                  <i
                    v-if="!row.hideUp"
                    class="icon icon-up"
                    @click="moveNavi(-1,row.id)"
                  />
                </mix-tooltip>
                <mix-tooltip
                  :enterable="false"
                  content="下移"
                  popper-class="user-table-tooltip weight"
                  placement="top"
                  effect="light"
                >
                  <i
                    v-if="!row.hideDown"
                    class="icon icon-down"
                    @click="moveNavi(1,row.id)"
                  />
                </mix-tooltip>
                <mix-tooltip
                  :enterable="false"
                  content="删除"
                  popper-class="user-table-tooltip weight"
                  placement="top"
                  effect="light"
                >
                  <i
                    class="icon icon-delete"
                    @click="deleteNavi(row)"
                  />
                </mix-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div
          v-else
          style="width: 100%; text-align: center; color: #aaa"
        >
          <img src="../../../../assets/image/no_data.png">
        </div>
      </div>
    </template>
    <template
      v-if="haveHomePage"
    >
      <div
        class="listHead"
      >
        <div>
          <div class="sCircle" />
          <span style="font-size: 16px; font-weight: 700">首页内容管理</span>
        </div>
        <div
          class="addLinkBtn"
        >
          <el-button
            class="plainBtn cancel-button"
            size="small"
            @click="addHomePage"
          >
            添加
          </el-button>
        </div>
      </div>

      <div class="Pagedata">
        <el-table
          v-if="homePageList.length > 0"
          :data="homePageList"
          border
          :header-cell-style="headCss"
          style="width: 100%"
        >
          <el-table-column
            prop="catalogName"
            label="栏目名称"
            align="center"
          />
          <el-table-column
            prop="contentTypeName"
            label="内容显示类型"
            align="center"
          />
          <el-table-column
            prop="content"
            label="内容设置项"
            align="center"
          />
          <el-table-column
            label="操作"
            align="center"
            width="220"
          >
            <template slot-scope="{ row }">
              <div class="tableRow">
                <mix-tooltip
                  :enterable="false"
                  content="上移"
                  popper-class="user-table-tooltip weight"
                  placement="top"
                  effect="light"
                >
                  <i
                    v-if="row.id !== homePageList[0].id"
                    class="icon icon-up"
                    @click="moveHomePage(-1,row.id)"
                  />
                </mix-tooltip>
                <mix-tooltip
                  :enterable="false"
                  content="下移"
                  popper-class="user-table-tooltip weight"
                  placement="top"
                  effect="light"
                >
                  <i
                    v-if="row.id !== homePageList[homePageList.length-1].id"
                    class="icon icon-down"
                    @click="moveHomePage(1,row.id)"
                  />
                </mix-tooltip>
                <mix-tooltip
                  :enterable="false"
                  content="修改"
                  popper-class="user-table-tooltip weight"
                  placement="top"
                  effect="light"
                >
                  <i
                    class="icon icon-set"
                    @click="setHomePage(row)"
                  />
                </mix-tooltip>
                <mix-tooltip
                  :enterable="false"
                  content="删除"
                  popper-class="user-table-tooltip weight"
                  placement="top"
                  effect="light"
                >
                  <i
                    class="icon icon-delete"
                    @click="deleteHomePage(row)"
                  />
                </mix-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div
          v-else
          style="width: 100%; text-align: center; color: #aaa"
        >
          <img src="../../../../assets/image/no_data.png">
        </div>
      </div>
    </template>
    <div
      v-show="haveLink"
      class="listHead"
    >
      <div>
        <div class="sCircle" />
        <span style="font-size: 16px; font-weight: 700">友情链接管理</span>
      </div>
      <div
        class="addLinkBtn"
      >
        <el-button
          class="plainBtn cancel-button"
          size="small"
          @click="addLink"
        >
          添加
        </el-button>
      </div>
    </div>
    <div
      v-if="siteMsg.webTemplate === 'WEB-003' && tableData.length > 0 && haveLink"
      class="showLinkLabel"
    >
      友情链接显示样式：
      <el-radio-group
        v-model="showLink"
        @change="changeShowLink"
      >
        <el-radio :label="0">
          链接名称
        </el-radio>
        <el-radio :label="1">
          链接图标
        </el-radio>
      </el-radio-group>
    </div>
    <div class="Pagedata">
      <el-table
        v-if="tableData.length > 0 && haveLink"
        :data="tableData"
        border
        :header-cell-style="headCss"
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          label="ID"
          align="center"
          width="80"
        />
        <el-table-column
          prop="name"
          label="链接名称"
          align="center"
        />
        <el-table-column
          prop="linkIcon"
          label="链接图标"
          align="center"
        >
          <template
            slot-scope="scope"
            width="90"
          >
            <img
              style="max-width:226px;max-height:80px;border:none;"
              :src="scope.row.linkIcon"
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="link"
          label="链接地址"
          align="center"
        />
        <el-table-column
          label="操作"
          align="center"
          width="220"
        >
          <template slot-scope="{ row }">
            <div class="tableRow">
              <mix-tooltip
                :enterable="false"
                content="上移"
                popper-class="user-table-tooltip weight"
                placement="top"
                effect="light"
              >
                <i
                  v-if="row.name !== tableData[0].name"
                  class="icon icon-up"
                  @click="move(-1,row.id)"
                />
              </mix-tooltip>
              <mix-tooltip
                :enterable="false"
                content="下移"
                popper-class="user-table-tooltip weight"
                placement="top"
                effect="light"
              >
                <i
                  v-if="row.name !== tableData[tableData.length-1].name"
                  class="icon icon-down"
                  @click="move(1,row.id)"
                />
              </mix-tooltip>
              <mix-tooltip
                :enterable="false"
                content="修改"
                popper-class="user-table-tooltip weight"
                placement="top"
                effect="light"
              >
                <i
                  class="icon icon-set"
                  @click="setLink(row)"
                />
              </mix-tooltip>
              <mix-tooltip
                :enterable="false"
                content="删除"
                popper-class="user-table-tooltip weight"
                placement="top"
                effect="light"
              >
                <i
                  class="icon icon-delete"
                  @click="deleteRow(row)"
                />
              </mix-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div
        v-else
        style="width: 100%; text-align: center; color: #aaa"
      >
        <img src="../../../../assets/image/no_data.png">
      </div>
    </div>
    <!-- 弹窗 -->
    <mix-dialog
      ref="addDia"
      :modal="true"
      width="500px"
      :visible.sync="showDia"
    >
      <div
        slot="title"
        class="dialog-title"
      >
        <span v-if="!isSet">添加友情链接</span>
        <span v-else>修改友情链接</span>
      </div>
      <div class="formBody">
        <div class="flex_row dialog_row align_items">
          <div class="dialog_row_left required">
            <span>链接名称：</span>
          </div>
          <el-input
            v-model.trim="inputName"
            :maxlength="10"
            placeholder="请输入链接名称"
          />
        </div>

        <div class="flex_row dialog_row align_items">
          <div class="dialog_row_left required">
            <span>链接地址：</span>
          </div>
          <el-input
            v-model="inputLink"
            placeholder="请输入友情链接地址，以http或https开头"
          />
        </div>

        <div class="flex_row align_items">
          <div class="dialog_row_left unrequired">
            <span>链接图标：</span>
          </div>

          <div :class="['setting-content']">
            <div
              class="img-container logo-container"
              @click.stop="uploadPicture('logo')"
            >
              <img
                :src="linkIcon"
                :onerror="defaultLogoImage"
                alt=""
                class="image-item"
              >
              <div
                class="pos-handler application-handler"
              >
                <div class="icon-container">
                  <i
                    class="el-icon-view"
                    @click.stop="previewEvent(linkIcon)"
                  />
                </div>
                <div class="icon-container">
                  <i
                    class="el-icon-delete"
                    @click.stop="handleDeleteImage('logo')"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="add-match">
        <transition name="el-zoom-in-bottom">
          <div class="">
            <el-button
              class="plainBtn"
              size="medium"
              @click="closeDialog"
            >
              取消
            </el-button>
            <el-button
              size="medium"
              type="primary"
              @click="submitLink"
            >
              确认
            </el-button>
          </div>
        </transition>
      </div>
    </mix-dialog>

    <!--图片上传-->
    <Uploader
      v-if="showDia"
      ref="uploader"
      :limit="1"
      :upload-mode="'powerUp'"
      @uploadSuccess="handleUploadSuccess"
    />
    <el-dialog
      v-if="haveNavi"
      class="column-dia"
      :visible.sync="showTreeDialog"
      :append-to-body="true"
      width="500px"
    >
      <div
        slot="title"
        class="dialog-title"
      >
        <span>添加导航栏目</span>
      </div>
      <div
        class="min-scrollbar"
        style="max-height: 400px; overflow-y: auto; border: 1px solid #DCDFE6;"
      >
        <el-tree
          ref="navieltree"
          class="column-tree"
          show-checkbox
          :check-strictly="true"
          :data="naviTree"
          node-key="catalogId"
          :props="defaultProps"
          :expand-on-click-node="false"
          :default-expanded-keys="defaultExpandedKeys"
          :default-checked-keys="defaultCheckedKeys"
          :check-on-click-node="true"
          @check-change="handleCheckChange"
        />
      </div>
      <div class="tree-dialog-footer">
        <el-button @click="showTreeDialog = false">
          取消
        </el-button>
        <el-button
          type="primary"
          @click="naviConfirm"
        >
          确定
        </el-button>
      </div>
    </el-dialog>

    <!-- 添加首页内容 -->
    <mix-dialog
      v-if="haveHomePage"
      ref="editDia"
      :modal="true"
      width="560px"
      class="right-dialog"
      :visible.sync="showHomePageDialog"
      @close="handleClose"
    >
      <div
        slot="title"
        class="dialog-title"
      >
        <span>添加首页内容</span>
      </div>
      <div class="dialogBody min-scrollbar">
        <div class="newDialogBodyContent">
          <el-form
            ref="homePageForm"
            :model="homePageForm"
            :rules="rules"
            label-position="right"
            label-width="100px"
          >
            <el-form-item
              label="选择栏目"
              prop="catalogId"
            >
              <div
                class="pCatalogName"
                @click="openAllTreeDialog"
              >
                {{ homePageForm.name || '请选择栏目' }}
              </div>
            </el-form-item>
            <el-form-item
              label="栏目类型"
              prop="contentType"
            >
              <el-radio-group
                v-model="homePageForm.contentType"
                @change="changeContentType"
              >
                <el-radio :label="0">
                  内容列表
                </el-radio>
                <el-radio :label="1">
                  内容详情
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              v-if="homePageForm.contentType==0"
              label="标题样式"
              prop="styleId"
            >
              <el-radio-group v-model="homePageForm.styleId">
                <div
                  v-for="(value, key) in homePageStyleList"
                  :key="key"
                  class="homePageStyleDiv"
                >
                  <el-radio :label="value.styleId">
                    {{ value.styleName }}
                    <div>
                      <img
                        v-if="value.imgUrl"
                        :src="value.imgUrl"
                      >
                    </div>
                  </el-radio>
                </div>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              v-else
              label="选择内容"
              prop="contentId"
            >
              <div
                class="pCatalogName"
                @click="openContentDialog"
              >
                {{ homePageForm.contentTypeName || '请选择内容' }}
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div
        class="add-match"
      >
        <transition name="el-zoom-in-bottom">
          <div class="btn-box-fixed">
            <el-button
              size="medium"
              class="plainBtn"
              @click="showHomePageDialog = false"
            >
              取消
            </el-button>
            <el-button
              size="medium"
              type="primary"
              @click="saveHomePage"
            >
              确认
            </el-button>
          </div>
        </transition>
      </div>
    </mix-dialog>

    <el-dialog
      v-if="haveHomePage"
      :visible.sync="showAllTreeDialog"
      class="column-dia"
      width="500px"
      :append-to-body="true"
    >
      <div
        slot="title"
        class="dialog-title"
      >
        <span>所属栏目</span>
      </div>
      <div
        class="min-scrollbar"
        style="max-height: 400px; overflow-y: auto; border: 1px solid #DCDFE6;"
      >
        <el-tree
          ref="allTreeData"
          class="column-tree"
          :data="treeData"
          node-key="catalogId"
          :props="treeDataProps"
          :highlight-current="true"
          :expand-on-click-node="false"
          :default-expanded-keys="treeDataExpandedKeys"
        />
      </div>
      <div class="tree-dialog-footer">
        <el-button @click="showAllTreeDialog = false">
          取消
        </el-button>
        <el-button
          type="primary"
          @click="allTreeClick"
        >
          确定
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      v-if="haveHomePage"
      :visible.sync="showContentDialog"
      class="column-dia"
      width="500px"
      :append-to-body="true"
    >
      <div
        slot="title"
        class="dialog-title"
      >
        <span>选择内容</span>
      </div>
      <el-input
        v-model="homePageForm.keyword"
        placeholder="请输入所要查询的内容"
        class="input-with-select"
        @keypress.native.enter="getHomePageTitleList"
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          @click.stop="getHomePageTitleList"
        />
      </el-input>
      <div
        class="min-scrollbar"
        style="max-height: 300px; min-height: 250px; overflow-y: auto; border: 0px solid #DCDFE6;"
      >
        <el-radio-group
          v-if="contentList.length"
          v-model="homePageForm.contentId"
        >
          <div
            v-for="(value, key) in contentList"
            :key="key"
            class="homePageSearchRadioDiv"
          >
            <el-radio :label="value.contentId">
              {{ value.title }}
              <div style="width: 420px;" />
            </el-radio>
          </div>
        </el-radio-group>
        <div
          v-else
          style="width: 100%; text-align: center; color: #aaa"
        >
          <img src="../../../../assets/image/no_data.png">
        </div>
      </div>
      <div class="tree-dialog-footer">
        <el-button @click="showContentDialog = false">
          取消
        </el-button>
        <el-button
          type="primary"
          @click="contentDialogClick"
        >
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import api from './proxy';
import Uploader from '@/components/common/Uploader';
export default {
    name: 'WebPage',
    components: { Uploader },
    data () {
        return {
            pagination: {
                total: 0,
                current: 1,
                size: 10,
            },
            checkList: [],
            headCss: { 'background-color': '#F1FFFA' }, // 表头样式
            tableData: [],
            showDia: false,
            isSet: false,
            haveLink: false,
            StyleList: [],
            siteStyleSLists: [],
            catalog: null,
            inputName: '',
            inputLink: '',
            linkId: '',
            setRow: {},
            linkIcon: '', // 链接图标
            defaultLogoImage: 'this.src="' + require('../../../../assets/image/pic_add.png') + '"', // LOGO默认图
            siteMsg: {},
            haveNavi: false, // 是否显示导航管理
            haveHomePage: false, // 是否显示首页内容管理
            showTreeDialog: false, // 添加导航栏目对话框
            naviList: [], // 导航栏目列表
            naviTree: [], // 导航栏目树
            defaultProps: { // 栏目树配置项
                children: 'child',
                label: 'name',
            },
            defaultExpandedKeys: [], // 栏目树默认展开的key
            defaultCheckedKeys: [], // 栏目树选中的数组
            showHomePageDialog: false, // 设置首页内容侧边栏

            homePageForm: {
                'id': null, // 新增为null
                'siteId': 0,
                'catalogId': null,
                'contentType': 0, // 内容显示类型 0：内容列表 1：内容详情
                'styleId': null, // 样式id
                'contentId': null, // 内容id
                'name': '', // 栏目名
                'contentTypeName': '', // 内容名
                'keyword': '', // 搜索关键词
            },
            rules: {
                catalogId: [{ required: true, message: '请选择栏目', trigger: [ 'change', 'blur' ] }],
                contentType: [{ required: true, message: '显示类型', trigger: 'change' }],
                styleId: [{ required: true, message: '请选择标题样式', trigger: [ 'change', 'blur' ] }],
                contentId: [{ required: true, message: '请选择内容', trigger: [ 'change', 'blur' ] }],
                // image: [{ required: true, message: '请上传栏目缩略图', trigger: 'change' }],
                // catalogLink: [{ required: true, validator: checkLink, trigger: 'blur' }],
            },

            showLink: 0, // 展示类型 1：图标 0：链接

            showAllTreeDialog: false, // 全部栏目树对话框标记
            treeData: [], // 树状列表
            treeDataProps: { // 树状列表配置项
                children: 'children',
                label: 'name',
            },
            treeDataExpandedKeys: [], // 树状列表默认展开
            homePageStyleList: [], // 设置首页内容样式列表
            homePageList: [], // 首页

            showContentDialog: false, // 内容对话框标记
            contentList: [], // 文章搜索列表
        };
    },
    created () {
        this.siteMsg = JSON.parse(sessionStorage.getItem('websiteMsg'));
        if (this.siteMsg && this.siteMsg.webTemplate) {
            this.getModuleList();
            this.getPageManagePlugList();
            // this.catalogStyleList();

            if (this.siteMsg.webTemplate === 'WEB-003') {
                this.getNaviList();

                this.getHomePageList();

                this.getShowLink();
            } else if (this.siteMsg.webTemplate === 'WEB-004') {
                this.getNaviList();
            }

            // api.searchTreeList(params).then((res) => {
            //     if (res.errcode === 0) {
            //         // this.tableData = res.data.list;
            //     }
            // });
        }
    },
    methods: {
        preview () {
            this.$router.push({ name: 'mobileModules' });
        },
        // 获取插件列表
        getPageManagePlugList () {
            const params = {
                pageNo: 1,
                pageSize: 10,
                webSiteId: this.$route.query.siteId || this.$store.getters['system/getSiteList'][0].siteId,
            };
            api.getPartnerPageList(params).then((res) => {
                if (res.errcode === 0) {
                    this.tableData = res.data.list;
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        getModuleList () {
            api.getModuleList({ templateId: this.siteMsg.webTemplateId }).then((res) => {
                if (res.errcode === 0) {
                    console.log(res.data);
                    let ModuleList = res.data;
                    ModuleList.forEach((e) => {
                        if (e.moduleName === '友情链接') {
                            this.haveLink = true;
                        }
                        if (e.moduleName === '导航管理' && ['WEB-003', 'WEB-004'].includes(this.siteMsg.webTemplate)) {
                            this.haveNavi = true;
                        }
                        if (e.moduleName === '首页内容管理' && this.siteMsg.webTemplate === 'WEB-003') {
                            this.haveHomePage = true;
                        }
                    });
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        isURL (url) {
            if (!url) return false;
            const strRegex =
                '^((https|http|ftp)://)?' + // (https或http或ftp):// 可有可无
                "(([\\w_!~*'()\\.&=+$%-]+: )?[\\w_!~*'()\\.&=+$%-]+@)?" + // ftp的user@ 可有可无
                '(([0-9]{1,3}\\.){3}[0-9]{1,3}' + // IP形式的URL- 3位数字.3位数字.3位数字.3位数字
                '|' + // 允许IP和DOMAIN（域名）
                '(localhost)|' + // 匹配localhost
                "([\\w_!~*'()-]+\\.)*" + // 域名- 至少一个[英文或数字_!~*\'()-]加上.
                '\\w+\\.' + // 一级域名 -英文或数字 加上.
                '[a-zA-Z]{1,6})' + // 顶级域名- 1-6位英文
                '(:[0-9]{1,5})?' + // 端口- :80 ,1-5位数字
                // '((/?)|' + // a slash isn't required if there is no file name
                // "(/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+/?)$";
                '';
            const re = new RegExp(strRegex, 'i'); // 大小写不敏感
            if (re.test(encodeURI(url))) {
                return true;
            }
            return false;
        },
        // 添加事件
        addLink () {
            this.showDia = true;
        },
        // 取消事件
        closeDialog () {
            this.inputName = '';
            this.inputLink = '';
            this.linkIcon = '';
            this.showDia = false;
            this.isSet = false;
        },
        // 确认添加按钮
        submitLink () {
            if (this.inputName === '') {
                this.$message.error('请输入栏目名称');
            } else if (this.inputLink === '') {
                this.$message.error('请输入栏目链接');
            } else {
                if (this.isURL(this.inputLink)) {
                    let params = {};
                    if (this.isSet) {
                        params = {
                            name: this.inputName,
                            link: this.inputLink,
                            webSiteId: this.$route.query.siteId || this.$store.getters['system/getSiteList'][0].siteId,
                            rank: this.setRow.rank,
                            id: this.linkId,
                            linkIcon: this.linkIcon,
                        };
                    } else {
                        params = {
                            name: this.inputName,
                            link: this.inputLink,
                            webSiteId: this.$route.query.siteId || this.$store.getters['system/getSiteList'][0].siteId,
                            rank: this.tableData.length + 1,
                            id: '',
                            linkIcon: this.linkIcon,
                        };
                    }
                    console.log(params);
                    api.savePartner(params).then((res) => {
                        if (res.errcode === 0) {
                            this.showDia = false;

                            if (this.isSet) {
                                this.$message.success('修改成功');
                            } else {
                                this.$message.success('添加成功');
                            }
                            this.getPageManagePlugList();
                            this.inputName = '';
                            this.inputLink = '';
                            this.linkIcon = '';
                            this.isSet = false;
                            this.linkId = '';
                        } else {
                            this.$message.error(res.errmsg);
                        }
                    });
                } else {
                    this.$message.error('请输入合法的链接');
                }
            }
        },
        // 删除链接
        deleteRow (data) {
            console.log(data);
            this.$confirm('确认删除该链接吗?', '提示', {
                confirmButtonText: '确定',
                closeOnClickModal: false,
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                api.removePartner([Number(data.id)]).then((res) => {
                    if (res.errcode === 0) {
                        console.log(res);
                        this.$message.success('删除成功');
                        this.getPageManagePlugList();
                    } else {
                        this.$message.error(res.errmsg);
                    }
                });
            }).catch(() => {});
        },
        // 修改链接
        setLink (row) {
            console.log(row);
            this.showDia = true;
            this.isSet = true;
            this.inputName = row.name;
            this.inputLink = row.link;
            this.linkIcon = row.linkIcon;
            this.linkId = Number(row.id);
            this.setRow = row;
        },
        // 上下移
        move (data, id) {
            let params = {
                partnerId: id,
                operation: data,
                webSiteId: this.$route.query.siteId || this.$store.getters['system/getSiteList'][0].siteId,
            };
            api.changeRankPartner(params).then((res) => {
                if (res.errcode === 0) {
                    // console.log(res);
                    // this.$message.success('删除成功');
                    this.getPageManagePlugList();
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        detal (e) {
            this.showDia = true;
            this.catalog = e;
            this.StyleLists();
        },
        catalogStyleList () {
            const params = {
                siteId: this.$route.query.siteId || this.$store.getters['system/getSiteList'][0].siteId,
            };
            api.catalogStyleList(params).then((res) => {
                if (res.errcode === 0) {
                    this.StyleList = res.data.list;
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        StyleLists () {
            const params = {
                siteId: this.$route.query.siteId || this.$store.getters['system/getSiteList'][0].siteId,
            };
            api.siteStyleSLists(params).then((res) => {
                if (res.errcode === 0) {
                    let siteStyleSLists = res.data.list;
                    console.log('siteStyleSLists: ', siteStyleSLists);
                    // catalog.styleId

                    siteStyleSLists.forEach(e => {
                        e.active = (e.id === this.catalog.styleId ? 1 : 0);
                    });
                    this.siteStyleSLists = siteStyleSLists;
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        // 切换默认样式
        checkStyle (item, index) {
            console.log(this.siteStyleSLists);
            this.siteStyleSLists.forEach((e) => {
                e.active = 0;
            });
            this.siteStyleSLists[index].active = 1;
        },
        checkStyleApi () {
            let active = null;
            this.siteStyleSLists.forEach((e) => {
                if (e.active === 1) {
                    active = e;
                }
            });
            const params = {
                siteId: this.$route.query.siteId || this.$store.getters['system/getSiteList'][0].siteId,
                catalogId: this.catalog.id,
                styleId: active.id,
            };
            api.checkStyle(params).then((res) => {
                if (res.errcode === 0) {
                    this.showDia = false;
                    this.catalogStyleList();
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        checkPlug (e) {
            console.log(e);
            let params = {
                id: e.id,
                useType: e.useType.join(','),
                siteId: this.$route.query.siteId || this.$store.getters['system/getSiteList'][0].siteId,
            };
            api.checkPlug(params).then(e => {
                console.log(e);
            });
        },

        // 上传图片
        uploadPicture (type) {
            if (!this.$refs.uploader.isUploading) {
                this.$refs.uploader.init('logo');
            } else {
                this.$message.error({
                    type: 'error',
                    message: '文件上传中，请稍后再试',
                });
            }
        },
        // 图片上传成功
        handleUploadSuccess (list) {
            const curData = list && list[0];
            const curFiles = curData && curData.result;
            // let params = {};
            if (curData.status === 'succ') {
                console.log(1111, curFiles.fileUrl);
                console.log(2222, curFiles.filePath);
                this.linkIcon = curFiles.fileUrl;
            }
            this.$refs.uploader.isUploading = false;
        },
        // 图片预览
        previewEvent (src) {
            if (src) {
                window.open(src);
            } else {
                this.$message.error({
                    type: 'error',
                    message: '暂无图片',
                });
            }
        },

        // 处理图片删除
        handleDeleteImage (val) {
            this.linkIcon = '';
        },
        // 打开添加导航对话框
        openNaviDialog: function () {
            this.showTreeDialog = true;
            const params = {
                siteId: this.$route.query.siteId || this.$store.getters['system/getSiteList'][0].siteId,
            };
            api.searchTreeList(params).then((res) => {
                if (res.errcode === 0) {
                    // this.tableData = res.data.list;
                    if (this.siteMsg.webTemplate === 'WEB-004') {
                        res.data = res.data.filter(itm => ![-2, -1].includes(itm.catalogId));
                    }
                    this.naviTree = res.data;
                    this.defaultExpandedKeys = [];
                    this.defaultCheckedKeys = [];
                    this.naviTree.forEach(item => {
                        this.defaultExpandedKeys.push(item.catalogId);
                        if (item.isSelect) {
                            this.defaultCheckedKeys.push(item.catalogId);
                        }
                        item.child.forEach(childItem => {
                            if (childItem.isSelect) {
                                this.defaultCheckedKeys.push(childItem.catalogId);
                            }
                        });
                    });
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        // 添加导航选中时间
        handleCheckChange: function (node, flag) {
            // console.log(node, node.pCatalogId, flag);
            // 先判断有多少个
            if (flag === true) {
                // 判断选中子节点
                if (node.pCatalogId > 0) {
                    this.$refs.navieltree.setChecked(node.pCatalogId, true);
                }

                //  判断有多少个一级节点
                let nodes = this.$refs.navieltree.getCheckedNodes();
                let level1nodes = nodes.filter(item => item.pCatalogId === 0);
                if (level1nodes.length > 7) {
                    this.$message.error('最多支持添加7个一级栏目');
                    this.$refs.navieltree.setChecked(node.catalogId, false);
                    if (node.pCatalogId > 0) {
                        this.$refs.navieltree.setChecked(node.pCatalogId, false);
                    }
                }
            }
            // 判断取消一级节点
            if (node.pCatalogId === 0 && flag === false) {
                node.child.forEach(item => {
                    this.$refs.navieltree.setChecked(item.catalogId, false);
                });
            }
        },
        // 导航栏列表
        getNaviList: function () {
            const params = {
                siteId: this.$route.query.siteId || this.$store.getters['system/getSiteList'][0].siteId,
            };
            api.getNavi(params).then((res) => {
                if (res.errcode === 0) {
                    this.naviList = res.data;

                    this.naviList.forEach((item, index) => {
                        if (index === 0) {
                            item.hideUp = true;
                        } else {
                            item.hideUp = false;
                        }
                        if (index === this.naviList.length - 1) {
                            item.hideDown = true;
                        } else {
                            item.hideDown = false;
                        }
                        item.child.forEach((childItem, childIndex) => {
                            if (childIndex === 0) {
                                childItem.hideUp = true;
                            } else {
                                childItem.hideUp = false;
                            }
                            if (childIndex === item.child.length - 1) {
                                childItem.hideDown = true;
                            } else {
                                childItem.hideDown = false;
                            }
                        });
                    });
                    this.naviList.forEach(item => {
                        item.children = item.child;
                    });
                    this.naviList.unshift({
                        name: '首页',
                        id: 0,
                        children: [],
                    });
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        // 添加导航确认按钮
        naviConfirm: function () {
            let catalogIds = this.$refs.navieltree.getCheckedKeys();
            let params = {
                siteId: this.$route.query.siteId || this.$store.getters['system/getSiteList'][0].siteId,
                catalogIds: catalogIds,
            };
            api.addNavi(params).then(res => {
                console.log(res);
                if (res.errcode === 0) {
                    this.showTreeDialog = false;
                    // 刷新列表
                    this.getNaviList();
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        // 导航上下移
        moveNavi (data, id) {
            let params = {
                id: id,
                operation: data,
                siteId: this.$route.query.siteId || this.$store.getters['system/getSiteList'][0].siteId,
            };
            api.moveNavi(params).then((res) => {
                if (res.errcode === 0) {
                    // console.log(res);
                    // 刷新列表
                    this.getNaviList();
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        // 删除链接
        deleteNavi (data) {
            console.log(4444444, data);
            this.$confirm('确认删除该导航吗?', '提示', {
                confirmButtonText: '确定',
                closeOnClickModal: false,
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                console.log(555555, data.id);
                api.deleteNavi({ id: Number(data.id), catalogId: Number(data.catalogId) }).then((res) => {
                    if (res.errcode === 0) {
                        console.log(res);
                        this.$message.success('删除成功');
                        // 刷新列表
                        this.getNaviList();
                    } else {
                        this.$message.error(res.errmsg);
                    }
                });
            }).catch(() => {});
        },
        // 打开设置首页内容侧边栏
        addHomePage: function () {
            this.showHomePageDialog = true;

            this.homePageForm.id = null;
            this.homePageForm.siteId = 0;
            this.homePageForm.catalogId = null;
            this.homePageForm.contentType = 0;
            this.homePageForm.styleId = 0;
            this.homePageForm.contentId = null;
            this.homePageForm.name = '';
            this.homePageForm.contentTypeName = '';
            this.homePageForm.keyword = '';

            api.getHomePageStyle({}).then((res) => {
                if (res.errcode === 0) {
                    this.homePageStyleList = res.data;
                    // 校验清除
                    this.$refs.homePageForm.resetFields();
                } else {
                    this.$message.error(res.errmsg);
                }
            });
            this.getTreeList();
        },
        // 保存首页内容
        saveHomePage: function () {
            console.log(222222, this.$refs.homePageForm);
            this.$refs.homePageForm.validate((valid) => {
                if (valid) {
                    // const params = {
                    //     ...this.column,
                    //     siteId: this.siteId,
                    // };
                    api.addHomePage(this.homePageForm).then(res => {
                        if (res.errcode === 0) {
                            // this.$message.success('保存成功');
                            this.showHomePageDialog = false;
                            // 刷新列表
                            this.getHomePageList();
                        } else {
                            this.$message.error(res.errmsg);
                        }
                    });
                }
            });
        },
        // 关闭弹窗清空数据
        handleClose () {
            this.siteForm = {
                name: '',
                logo: '',
                orgType: '0',
                orgId: '1',
                description: '',
                webTemplate: '',
                h5Template: '',
                address: '',
                addressId: '',
                level: '3',
                copyright: '', // 版权信息
                icpFilingCode: '', // ICP备案号
                policeFilingCode: '', // 公安备案号
            };
            this.peopleForm = {
                siteOwner: '',
            };
        },
        // 设置链接图标显示方式事件
        changeShowLink: function () {
            this.setShowLink(this.showLink);
        },
        // 设置链接图标显示方式
        setShowLink: function (flag) {
            const params = {
                siteId: this.$route.query.siteId || this.$store.getters['system/getSiteList'][0].siteId,
                label: flag,
            };
            api.setShowLink(params).then((res) => {
                if (res.errcode === 0) {
                    this.showLink = flag;
                    this.getShowLink();
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        // 获取链接图标显示方式
        getShowLink: function (flag) {
            const params = {
                siteId: this.$route.query.siteId || this.$store.getters['system/getSiteList'][0].siteId,
            };
            api.getShowLink(params).then((res) => {
                if (res.errcode === 0) {
                    this.showLink = parseInt(res.data.showLabel);
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        // 打开所有栏目对话框
        openAllTreeDialog: function () {
            this.showAllTreeDialog = true;

            this.$nextTick(() => {
                if (this.homePageForm.catalogId !== null) {
                    this.$refs.allTreeData.setCurrentKey(this.homePageForm.catalogId);
                }
            });
        },
        // 获取树状列表
        getTreeList () {
            let parmas = {
                isShowDisable: 1,
                siteId: this.$route.query.siteId || this.$store.getters['system/getSiteList'][0].siteId,
            };
            api.getTreeList(parmas).then(res => {
                const all = {
                    catalogId: 0,
                    catalogLevel: 0,
                    pCatalogId: null,
                    name: '站点栏目',
                    type: '0',
                    image: '',
                    describe: '',
                    catalogLink: '',
                    rank: 0,
                    status: 0,
                    children: [],
                    disabled: true,
                };
                all.children = res.data.value.catalogList;
                console.log(this.treeData);

                this.treeDataExpandedKeys = [0];

                all.children.forEach(item => {
                    this.treeDataExpandedKeys.push(item.catalogId);
                });

                // this.treeData = [all];
                this.treeData = all.children;
            });
        },
        // 首页内容列表
        getHomePageList: function () {
            const params = {
                siteId: this.$route.query.siteId || this.$store.getters['system/getSiteList'][0].siteId,
            };
            api.getHomePage(params).then((res) => {
                if (res.errcode === 0) {
                    // this.tableData = res.data.list;
                    console.log(4444, res.data);
                    this.homePageList = res.data;

                    this.homePageList.forEach(item => {
                        if (item.contentType) {
                            item.content = '内容标题：' + item.content;
                        } else {
                            item.content = '列表样式：' + item.content;
                        }
                    });
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        // treeData确认按钮
        allTreeClick: function () {
            let nodes = this.$refs.allTreeData.getCurrentNode();
            console.log(7777, nodes);
            if (nodes) {
                this.showAllTreeDialog = false;
                if (this.homePageForm.catalogId !== nodes.catalogId) {
                    this.homePageForm.contentTypeName = '';
                    this.homePageForm.contentId = null;
                }
                this.homePageForm.siteId = nodes.siteId;
                this.homePageForm.catalogId = nodes.catalogId;
                this.homePageForm.name = nodes.name;
            } else {
                this.$message.error('请选择栏目');
            }
        },
        // 打开选择内容对话框
        openContentDialog: function () {
            if (this.homePageForm.catalogId === null) {
                this.$message.error('请选择栏目');
                return;
            }
            this.showContentDialog = true;
            this.getHomePageTitleList();
        },
        // 调用搜索文章接口
        getHomePageTitleList: function () {
            let params = {
                siteId: this.$route.query.siteId || this.$store.getters['system/getSiteList'][0].siteId,
                catalogId: this.homePageForm.catalogId === 0 ? null : this.homePageForm.catalogId,
                keyword: this.homePageForm.keyword,
            };
            this.contentList = [];
            api.getHomePageTitleList(params).then((res) => {
                if (res.errcode === 0) {
                    this.contentList = res.data;
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        // 首页列表上下移
        moveHomePage (data, id) {
            let params = {
                id: id,
                operation: data,
                siteId: this.$route.query.siteId || this.$store.getters['system/getSiteList'][0].siteId,
            };
            api.moveHomePage(params).then((res) => {
                if (res.errcode === 0) {
                    // console.log(res);
                    // 刷新列表
                    this.getHomePageList();
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        // 删除链接
        deleteHomePage (data) {
            console.log(4444444, data);
            this.$confirm('确认删除该内容吗?', '提示', {
                confirmButtonText: '确定',
                closeOnClickModal: false,
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                console.log(555555, data.id);
                api.deleteHomePage({ id: Number(data.id) }).then((res) => {
                    if (res.errcode === 0) {
                        console.log(res);
                        this.$message.success('删除成功');
                        // 刷新列表
                        this.getHomePageList();
                    } else {
                        this.$message.error(res.errmsg);
                    }
                });
            }).catch(() => {});
        },
        // 修改导航
        setHomePage (row) {
            console.log(row);

            this.showHomePageDialog = true;

            this.homePageForm.id = row.id;
            this.homePageForm.siteId = row.siteId;
            this.homePageForm.catalogId = row.catalogId;
            this.homePageForm.contentType = row.contentType;
            this.homePageForm.styleId = row.styleId;
            this.homePageForm.contentId = row.contentId;
            this.homePageForm.name = row.catalogName;
            this.homePageForm.contentTypeName = row.content;
            this.homePageForm.keyword = '';

            api.getHomePageStyle({}).then((res) => {
                if (res.errcode === 0) {
                    this.homePageStyleList = res.data;
                } else {
                    this.$message.error(res.errmsg);
                }
            });
            this.getTreeList();
        },
        // 修改显示类型
        changeContentType (row) {
            if (this.homePageForm.contentType) {
                this.homePageForm.contentId = null;
                this.homePageForm.contentTypeName = '';
            } else {
                this.homePageForm.contentId = 0;
                this.homePageForm.styleId = 0;
            }
        },
        // 关闭选择内容对话框
        contentDialogClick: function () {
            let obj = this.contentList.find(item => item.contentId === this.homePageForm.contentId);
            if (obj) {
                this.homePageForm.contentTypeName = obj.title;
            }
            this.showContentDialog = false;
        },
    },
};
</script>
<style lang="scss" scoped>
.listHead {
  padding-left: 24px;
  padding-right: 24px;
  width: 100%;
  height: 53px;
  line-height: 53px;
  background-color: #fff;
  margin-top: 10px;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.sCircle {
  margin-bottom: 2px;
  margin-right: 10px;
  display: inline-block;
  border: 2px solid #ccc;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
.Pagedata {
  padding: 16px 23px;
  width: 100%;
  background-color: #fff;
  display: flex;
  &.tips {
      padding-bottom: 0;
  }
}

.showLinkLabel {
  padding: 16px 23px 0px 23px;
  width: 100%;
  background-color: #fff;
  display: flex;
  line-height: 14px;
}
.data_item {
  width: 312px;
  border: 1px solid #eee;
  cursor: pointer;
  margin-right: 20px;
  .data_item_head {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    right: -21px;
    span{
      font-size: 15px;
      font-weight: bold;
      width: 60px;
      line-height: 30px;
      overflow:hidden; //超出的文本隐藏
      text-overflow:ellipsis; //溢出用省略号显示
      white-space:nowrap; //溢出不换行
    }
    img {
      position: relative;
      right: -80px;
      width: 51px;
      height: 51px;
    }
  }
  .data_item_head2 {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    right: -130px;
    img {
      width: 51px;
      height: 51px;
    }
  }
  .data_item_body {
    // width: 100%;
    height: 94px;
    margin: 0 16px;
    // border: 1px solid #eee;
    img {
      width: 100%;
      height: 100%;
    }

  }

  .data_item_bottom {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 5px 0;

    span {
      font-size: 14px;
      font-weight: 400;

    }
  }
}
.add-match {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
.required {
  display: block;
  &::before {
      content: '*';
      color: #F56C6C;
      margin-right: 4px;
  }
}
.unrequired {
  display: block;
  &::before {
      content: '*';
      color: transparent;
      margin-right: 4px;
  }
}
.formBody /deep/ .el-input {
  width: 100%;
}
.tableRow{
    &.navi {
        .icon {
            margin-top: 5px;
            margin-left: 20px;
        }
    }
  span{
    margin-right: 15px;
    cursor: pointer;
  }
  span:hover{
    color: #2ed095;
  }
  padding-right: 20px;
  .icon {
      margin-top: 5px;
      margin-left: 20px;
      // padding: 0 15px;
      display: inline-block;
      width: 14px;
      height: 14px;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      outline: none;
      cursor: pointer;
      &.icon-set {
              background-image: url("../../../../assets/icon/icon_special_edit_grey.png");
          &:hover {
              background-image: url("../../../../assets/icon/icon_special_edit_green.png");
          }
      }
      &.icon-up {
          background-image: url("../../../../assets/icon/icon_up_unactive.png");
          &:hover {
              background-image: url("../../../../assets/icon/icon_up.png");
          }
      }
      &.icon-down {
          background-image: url("../../../../assets/icon/icon_down_unactive.png");
          &:hover {
              background-image: url("../../../../assets/icon/icon_down.png");
          }
      }
      &.icon-delete {
          background-image: url("../../../../assets/icon/icon_delete_unactive.png");
          &:hover {
              background-image: url("../../../../assets/icon/icon_delete.png");
          }
      }
  }
}
.addLinkBtn{
  cursor: pointer;
}
.addLinkBtn:hover{
  color: #2ed095;
}
.flex_row {
  display: flex;
}
.align_items{
align-items:center;
}
.warp {
  flex-wrap: wrap;
}
.row_top {
  padding: 51px 0 0 0;
}
.row_top2{
  padding-top: 20px;
  bottom: 10px;
  right: 3px !important;
  span{
    line-height: 20px;
  }
}
.dialog_row {
  margin-bottom: 16px;
}
.plainBtn {
  border-color: #2ed095 !important;
  color: #2ed095;
}
.dialog_row_left {
  margin-right: 10px;
  display: inline-block;
  width: 105px;
}
.activeBoder{
      background: #F2FCF9;
      // background: chartreuse;
    }

.setting-content {
width: 100%;

.img-container {
    background-color: #F0F0F0;
    margin-bottom: 16px;
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;

    &:hover {
    .pos-handler {
        bottom: 0 !important;
    }
    }

    &.logo-container {
    width: 226px;
    height: 80px;
    }

    &.wallpaper-container {
    width: 226px;
    height: 80px;
    }

    .image-item {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    }

    .pos-handler {
    position: absolute;
    left: 0;
    width: 100%;
    background: rgba(150, 150, 150, .6);
    color: #fff;
    -webkit-transition: bottom .2s linear;
    -moz-transition: bottom .2s linear;
    -ms-transition: bottom .2s linear;
    -o-transition: bottom .2s linear;
    transition: bottom .2s linear;
    display: flex;

    [class^=el-icon] {
        padding: 5px;
        font-size: 1.2rem;
        cursor: pointer;
        &:hover {
        color: #2ED095;
        }
    }

    .icon-container {
        width: 50%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &.application-handler {
        height: 30px;
        bottom: -30px;
    }
    }
}

.common-tips {
    color: #999999;
    font-size: 12px;
}
}
.homePageStyleDiv {
    padding: 12px 0;
    img {
        margin-top: 12px;
        margin-left: 24px;
        max-width: 320px;
        max-height: 240px;
    }
}

.homePageSearchRadioDiv {
    padding: 16px 0 0px 0;
    width: 100%;
}

</style>

<style lang="scss">

    .newDialogBodyContent {
        height: calc(100% - 60px);
        .el-form {
            margin-top: 20px;
            padding: 0 24px;
            .el-form-item {
                .pCatalogName {
                    padding: 0 10px;
                    width: 360px;
                    border: 1px solid #DBDEE5;
                    border-radius: 4px;
                    background: #F2F4FC;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    cursor: pointer;
                    &.locked {
                        color: #606266;
                        cursor: not-allowed;
                    }
                }
            }
        }
    }

.dialogBody {
    width: 92%;
    // min-width: 560px;
    margin-left: 4%;
    height: 90%;
    overflow: auto;
}
.btn-box-fixed {
    position: fixed;
    bottom: 10px;
    height: 50px;
    width: 560px;
    background: #fff;
    z-index: 99;
    margin-bottom: 0px !important;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
